import './Documentation.css';
import React,{ useEffect, useRef } from 'react';
import {
    ReflexContainer,
    ReflexSplitter,
    ReflexElement
} from 'react-reflex';
import { useParams, useLocation, useNavigate, Link } from "react-router-dom";
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import Zoom from 'react-medium-image-zoom';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import LinkIcon from '@mui/icons-material/Link';
import Button from '@mui/material/Button';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MenuIcon from '@mui/icons-material/Menu';

import Installation from './GettingStarted/Installation';
import Usage from './GettingStarted/Usage';

import Miscellaneous from './ActionTask/Miscellaneous';
import Browser from './ActionTask/Browser';
import Storages from './ActionTask/Storages';
import Json from './ActionTask/Json';
import Text from './ActionTask/Text';
import Excel from './ActionTask/Excel';
import Gmail from './ActionTask/Gmail';
import Calendar from './ActionTask/Calendar';
import Drive from './ActionTask/Drive';
import Docs from './ActionTask/Docs';
import Spreadsheet from './ActionTask/Spreadsheet';
import AwsS3 from './ActionTask/AwsS3';
import Ftp from './ActionTask/Ftp';
import WebService from './ActionTask/WebService';
import Filemaker from './ActionTask/Filemaker';
import Control from './ActionTask/Control';

import GmailConnection from './Connections/Gmail';
import CalendarConnection from './Connections/Calendar';
import DriveConnection from './Connections/Drive';
import DocsConnection from './Connections/Docs';
import SpreadsheetConnection from './Connections/Spreadsheet';
import AwsS3Connection from './Connections/AwsS3';
import FtpConnection from './Connections/Ftp';
import FilemakerConnection from './Connections/Filemaker';

import Get from './Functions/Get';
import Dates from './Functions/Dates';
import Texts from './Functions/Texts';
import Numbers from './Functions/Numbers';
import Logical from './Functions/Logical';

const innerHeight = window.innerHeight;

function Documentation(props) {
    const { translate, SnackbarAlert, Intl } = props;
    const navigate = useNavigate();
    const { main, sub } = useParams();
    const { hash } = useLocation();

    const [searchDocs, setSearchDocs] = React.useState("");

    const menus = [
        {
            gettingstarted: [
                {
                    subMenu: "installation"
                    ,contents: [
                        { hash: "chromeextension" }
                    ]
                }
                ,{
                    subMenu: "usage"
                    ,contents: [
                        { hash: "getcssselector" }
                        ,{ hash: "makeyourfirstrobot" }
                        ,{ hash: "runyourrobot" }
                        ,{ hash: "schedulerobotrun" }
                    ]
                }
            ]
        },
        {
            actiontask: [
                {
                    subMenu: "miscellaneous"
                    , contents: [
                        { hash: "comment" }
                        ,{ hash: "setvariable" }
                    ]
                }
                ,{
                    subMenu: "browser"
                    ,contents: [
                        { hash: "openbrowser" }
                        ,{ hash: "typetext" }
                        ,{ hash: "typepassword" }
                        ,{ hash: "click" }
                        ,{ hash: "selectoption" }
                        ,{ hash: "keyboardpress" }
                        ,{ hash: "downloadfile" }
                        ,{ hash: "uploadfile" }
                        ,{ hash: "gettext" }
                        ,{ hash: "clickpoint" }
                        ,{ hash: "takescreenshot" }
                        ,{ hash: "pagepdf" }
                        ,{ hash: "hover" }
                        ,{ hash: "scrapepage" }
                        ,{ hash: "extractdatafromtable" }
                        ,{ hash: "findelement" }
                        ,{ hash: "geturl" }
                        ,{ hash: "getattribute" }
                        ,{ hash: "waitforselector" }
                        ,{ hash: "draganddrop" }
                        ,{ hash: "injectjavascript" }
                        ,{ hash: "gotourl" }
                        ,{ hash: "goback" }
                        ,{ hash: "opennewtab" }
                        ,{ hash: "switchtab" }
                        ,{ hash: "showtabs" }
                        ,{ hash: "closetab" }
                        ,{ hash: "closebrowser" }
                    ]
                }
                ,{
                    subMenu: "storages"
                    ,contents: [
                        { hash: "listfiles" }
                        ,{ hash: "renamefile" }
                        ,{ hash: "movefiles" }
                        ,{ hash: "deletefiles" }
                        ,{ hash: "copyfiles" }
                        ,{ hash: "compressfiles" }
                        ,{ hash: "decompressfiles" }
                    ]
                }
                ,{ 
                    subMenu: "json"
                    ,contents: [
                        { hash: "createarray" }
                        ,{ hash: "getelementfromarray" }
                        ,{ hash: "createobject" }
                        ,{ hash: "getvaluefromobject" }
                    ]
                }
                ,{
                    subMenu: "text"
                    ,contents: [
                        { hash: "createtext" }
                        ,{ hash: "splittext" }
                        ,{ hash: "replacetext" }
                        ,{ hash: "matchtext" }
                        ,{ hash: "readtext" }
                        ,{ hash: "convertpdftotext" }
                    ]
                }
                ,{ 
                    subMenu: "excel"
                        ,contents: [
                        { hash: "createnewfile" }
                        ,{ hash: "getsheetnames" }
                        ,{ hash: "changesheetname" }
                        ,{ hash: "selectsheet" }
                        ,{ hash: "readcell" }
                        ,{ hash: "writecell" }
                        ,{ hash: "readrange" }
                        ,{ hash: "writerange" }
                        ,{ hash: "deleterange" }
                        ,{ hash: "convertexceltocsv" }
                        ,{ hash: "writecsv" }
                        ,{ hash: "readcsv" }
                        ,{ hash: "appendvaluetocsvfile" }
                    ]
                }
                ,{ 
                    subMenu: "gmail"
                    ,contents: [
                        { hash: "sendmail" }
                        ,{ hash: "getgmail" }
                        ,{ hash: "gmaildownloadattachments" }
                    ]
                }
                ,{ 
                    subMenu: "calendar"
                    ,contents: [
                        { hash: "getcalendarevents" }
                        ,{ hash: "createcalendarevent" }
                        ,{ hash: "removecalendarevent" }
                    ]
                }
                ,{ 
                    subMenu: "drive"
                    ,contents: [
                        { hash: "createdrivefile" }
                        ,{ hash: "getdrivefile" }
                    ]
                }
                ,{ 
                    subMenu: "docs"
                    ,contents: [
                        { hash: "createdocs" }
                        ,{ hash: "getdocs" }
                        ,{ hash: "docsinsertparagraph" }
                    ]
                }
                ,{ 
                    subMenu: "spreadsheet", 
                    contents: [
                        { hash: "createspreadsheet" }
                        ,{ hash: "getspreadsheet" }
                        ,{ hash: "getvalues" }
                        ,{ hash: "updatevalues" }
                        ,{ hash: "appendvalues" }
                        ,{ hash: "clearvalues" }
                        ,{ hash: "duplicatesheet" }
                        ,{ hash: "downloadsheets" }
                        ,{ hash: "appendsheet" }
                    ]
                }
                ,{ 
                    subMenu: "awss3"
                    ,contents: [
                        { hash: "uploads3file" }
                        ,{ hash: "downloads3file" }
                    ]
                }
                ,{ 
                    subMenu: "ftp"
                    ,contents: [
                        { hash: "uploadfiletoftp" }
                        ,{ hash: "downloadfilefromftp" }
                    ]
                }
                ,{
                    subMenu: "webservice"
                    ,contents: [
                        { hash: "httprequest" }
                        ,{ hash: "getfilefromurl" }
                    ]
                }
                ,{ 
                    subMenu: "filemaker"
                    ,contents: [
                        { hash: "getrecords" }
                        ,{ hash: "createrecord" }
                        ,{ hash: "getsinglerecordbyid" }
                        ,{ hash: "editrecord" }
                        ,{ hash: "deleterecord" }
                        ,{ hash: "duplicaterecord" }
                        ,{ hash: "findrecords" }
                        ,{ hash: "executescript" }
                        ,{ hash: "uploadtocontainerfield" }
                        ,{ hash: "setglobalfields" }
                    ]
                }
                ,{ 
                    subMenu: "control"
                    ,contents: [
                        { hash: "if" }
                        ,{ hash: "loop" }
                        ,{ hash: "forearch" }
                        ,{ hash: "breakif" }
                        ,{ hash: "wait" }
                        ,{ hash: "runjavascript" }
                    ]
                }
            ]
        },
        {
            connections: [
                { 
                    subMenu: "gmail"
                    ,contents: [
                        { hash: "createaconnectionwithgmail" }
                    ]
                }
                ,{ 
                    subMenu: "drive"
                    ,contents: [
                        { hash: "createaconnectionwithdrive" }
                    ]
                }
                ,{ 
                    subMenu: "calendar"
                    ,contents: [
                        { hash: "createaconnectionwithcalendar" }
                    ]
                }
                ,{ 
                    subMenu: "docs"
                    ,contents: [
                        { hash: "createaconnectionwithdocs" }
                    ]
                }
                ,{ 
                    subMenu: "spreadsheet"
                    ,contents: [
                        { hash: "createaconnectionwithspreadsheet" }
                    ]
                }
                ,{ 
                    subMenu: "awss3"
                    ,contents: [
                        { hash: "createaconnectionwithawss3" }
                    ]
                }
                ,{
                    subMenu: "ftp"
                    ,contents: [
                        { hash: "createaconnectionwithftp" }
                    ]
                }
                ,{ 
                    subMenu: "filemaker"
                    ,contents: [
                        { hash: "createaconnectionwithfilemaker" }
                    ]
                }
            ]
        },
        {
            functions: [
                { 
                    subMenu: "get"
                    ,contents: [
                        { hash: "fxgetcurrentdate" }
                        ,{ hash: "fxgetcurrenttime" }
                        ,{ hash: "fxgetcurrenttimestamp" }
                        ,{ hash: "fxgetfilesizeiniytes" }
                        ,{ hash: "fxgetnumberoffiles" }
                        ,{ hash: "fxgetscriptparameter" }
                    ]
                }
                ,{ 
                    subMenu: "date"
                    ,contents: [
                        { hash: "fxday" }
                        ,{ hash: "fxdayname" }
                        ,{ hash: "fxdayofweek" }
                        ,{ hash: "fxdayofyear" }
                        ,{ hash: "fxmonth" }
                        ,{ hash: "fxmonthname" }
                        ,{ hash: "fxweekofyear" }
                        ,{ hash: "fxyear" }
                        ,{ hash: "fxsetdate" }
                    ]
                }
                ,{ 
                    subMenu: "text"
                    ,contents: [
                        { hash: "fxtostring" }
                        ,{ hash: "fxleft" }
                        ,{ hash: "fxmiddle" }
                        ,{ hash: "fxright" }
                        ,{ hash: "fxstringlength" }
                        ,{ hash: "fxtolower" }
                        ,{ hash: "fxtoupper" }
                        ,{ hash: "fxpatterncount" }
                        ,{ hash: "fxsubstitute" }
                        ,{ hash: "fxtotrim" }
                        ,{ hash: "fxtotrimall" }
                        ,{ hash: "fxindexofstring" }
                        ,{ hash: "fxsplit" }
                        ,{ hash: "fxmatch" }
                    ]
                }
                ,{ 
                    subMenu: "number"
                    ,contents: [
                        { hash: "fxtonumber" }
                        ,{ hash: "fxrandom" }
                        ,{ hash: "fxtoceiling" }
                        ,{ hash: "fxtofloor" }
                    ]
                }
                ,{ 
                    subMenu: "logical"
                    ,contents: [
                        { hash: "fxif" }
                        ,{ hash: "fxcase" }
                        ,{ hash: "fxisempty" }
                    ]
                }
            ]
        }
    ];
    const [selectedMainMenu, setSelectedMainMenu] = React.useState("installation");
    const [selectedSubMenu, setSelectedSubMenu] = React.useState("");
    const [selectedHash, setSelectedHash] = React.useState("");
    const [showContents, setShowContents] = React.useState(false);

    const Contents = () => {
        return ((Object.values(menus[menus.findIndex(el => Object.keys(el).toString() === selectedMainMenu)] || [])[0])?.find(el => el.subMenu === selectedSubMenu))?.contents?.map((content, index) => (
            <ListItemButton
                key={content.hash}
                dense
                disableRipple
                selected={hash && (`#${content.hash}` === selectedHash)}
                className='hash'
                component={Link}
                to={`/control-center/documentation/${selectedMainMenu}/${selectedSubMenu}/#${content.hash}`}
                onClick={() => scrollToComponent(hash)}
            >
                <ListItemText primary={(index + 1 + ". ") + translate(content.hash?.replace(/-/g, ""))} />
            </ListItemButton>
        ))
    }

    const handleListItemClick = (mainMenu, subMenu) => {
        navigate(`/control-center/documentation/${mainMenu}/${subMenu}`)
    };

    const handleCopyLink = (providerID) => {
        navigator.clipboard.writeText(window.location.href);
        props.dispatch({
            type: 'UPDATE_SNACKBARALERT',
            SnackbarAlert: {
                open: true,
                severity: 'success',
                message: translate('copiedtoclipboard'),
                handleClose: () => handleCloseSnackbarAlert()
            }
        });
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const filterDocs = (mainMenu, searchValue) => {
        return mainMenu[Object.keys(mainMenu)[0]]?.filter((menu) => (
            translate(Object.keys(mainMenu)[0])?.toLowerCase().indexOf(searchValue?.toLowerCase()) > -1 ||
            translate(menu["subMenu"])?.toLowerCase().indexOf(searchValue?.toLowerCase()) > -1
        ))
    }   

    const scrollToComponent = (id) => {
        setTimeout(() => {
            id = id?.replace(/\#|\-/g, '');
            let element = document.getElementById(id);
            if (element) element.scrollIntoView({ behavior: "smooth", block: "start", inline: 'start' });
        }, 20);
    }

    useEffect(() => {
        if (hash) scrollToComponent(hash);
    }, [hash])

    useEffect(() => {
        if (sub) scrollToComponent("#sub-menu");
    }, [sub])

    useEffect(() => {
        setSelectedMainMenu(main);
        setSelectedSubMenu(sub);
        setSelectedHash(hash);
    }, [main, sub, hash])

    useEffect(() => {
        props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
        setTimeout(() => {
            props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
        }, 500);
    }, [])

    return (
        <Container maxWidth="xl">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box className='documentation-box'>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <ReflexContainer orientation="vertical">
                                    <ReflexElement
                                        size="250"
                                    >
                                        <Box p={1} sx={{ borderBottom: "1px solid rgb(229, 234, 242)" }}>
                                            <Box className='search-box'>
                                                <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                                    <SearchIcon />
                                                </IconButton>
                                                <InputBase
                                                    sx={{ ml: 1, flex: 1 }}
                                                    placeholder={translate('search')}
                                                    onChange={(e) => setSearchDocs(e.target.value)}
                                                    value={searchDocs}
                                                />
                                            </Box>
                                        </Box>
                                        <Box pl={2} sx={{ height: (innerHeight - 64 - 61 - 18), overflowY: "auto" }}>
                                            {menus.map((mainMenu) => (
                                                <List component="nav"
                                                    key={Object.keys(mainMenu).toString()}
                                                    subheader={<ListSubheader>{translate(Object.keys(mainMenu).toString())}</ListSubheader>}
                                                >
                                                    {filterDocs(mainMenu, searchDocs)?.map(({ subMenu }) => (
                                                        <ListItemButton
                                                            key={subMenu}
                                                            dense
                                                            selected={Object.keys(mainMenu).toString() === selectedMainMenu && subMenu === selectedSubMenu}
                                                            onClick={() => handleListItemClick(Object.keys(mainMenu).toString(), subMenu)}
                                                        >
                                                            <ListItemText primary={translate(subMenu)} />
                                                        </ListItemButton>
                                                    ))}
                                                </List>
                                            ))}
                                        </Box>
                                    </ReflexElement>
                                    <ReflexSplitter />
                                    <ReflexElement
                                        minSize="250"
                                    >
                                        <Box sx={{ height: "100%", overflow: "auto", paddingRight: (showContents ? "216px" : "10px") }}>
                                            {/* Details */}
                                            <Box px={5} py={2} sx={{ height: (innerHeight - 64 - 61 - 18), width: "100%", boxSizing: "border-box" }} id="submenu">
                                                <Typography variant="h4" gutterBottom>
                                                    {translate(selectedSubMenu)}
                                                </Typography>
                                                <Typography variant="body1" gutterBottom sx={{ marginBottom: 4 }}>
                                                    {translate(`subtitle__${selectedMainMenu}_${selectedSubMenu}`)}
                                                </Typography>
                                                {/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */}
                                                {/* installation */}
                                                {selectedMainMenu === 'gettingstarted' && selectedSubMenu === 'installation' &&
                                                    <Installation />}
                                                {/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */}
                                                {/* usage */}
                                                {selectedMainMenu === 'gettingstarted' && selectedSubMenu === 'usage' &&
                                                    <Usage />}
                                                {/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */}
                                                {/* actiontask */}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'miscellaneous' &&
                                                    <Miscellaneous />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'browser' &&
                                                    <Browser />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'storages' &&
                                                    <Storages />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'json' &&
                                                    <Json />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'text' &&
                                                    <Text />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'excel' &&
                                                    <Excel />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'gmail' &&
                                                    <Gmail />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'calendar' &&
                                                    <Calendar />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'drive' &&
                                                    <Drive />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'docs' &&
                                                    <Docs />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'spreadsheet' &&
                                                    <Spreadsheet />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'awss3' &&
                                                    <AwsS3 />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'ftp' &&
                                                    <Ftp />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'webservice' &&
                                                    <WebService />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'filemaker' &&
                                                    <Filemaker />}
                                                {selectedMainMenu === 'actiontask' && selectedSubMenu === 'control' &&
                                                    <Control />}
                                                {/* connections */}
                                                {selectedMainMenu === 'connections' && selectedSubMenu === 'gmail' &&
                                                    <GmailConnection />}
                                                {selectedMainMenu === 'connections' && selectedSubMenu === 'calendar' &&
                                                    <CalendarConnection />}
                                                {selectedMainMenu === 'connections' && selectedSubMenu === 'drive' &&
                                                    <DriveConnection />}
                                                {selectedMainMenu === 'connections' && selectedSubMenu === 'docs' &&
                                                    <DocsConnection />}
                                                {selectedMainMenu === 'connections' && selectedSubMenu === 'spreadsheet' &&
                                                    <SpreadsheetConnection />}
                                                {selectedMainMenu === 'connections' && selectedSubMenu === 'awss3' &&
                                                    <AwsS3Connection />}
                                                {selectedMainMenu === 'connections' && selectedSubMenu === 'ftp' &&
                                                    <FtpConnection />}
                                                {selectedMainMenu === 'connections' && selectedSubMenu === 'filemaker' &&
                                                    <FilemakerConnection />}
                                                {/* functions */}
                                                {selectedMainMenu === 'functions' && selectedSubMenu === 'get' &&
                                                    <Get />}
                                                {selectedMainMenu === 'functions' && selectedSubMenu === 'date' &&
                                                    <Dates />}
                                                {selectedMainMenu === 'functions' && selectedSubMenu === 'text' &&
                                                    <Texts />}
                                                {selectedMainMenu === 'functions' && selectedSubMenu === 'number' &&
                                                    <Numbers />}
                                                {selectedMainMenu === 'functions' && selectedSubMenu === 'logical' &&
                                                    <Logical />}
                                                {/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */}
                                            </Box>
                                            {/* Contents */}
                                            {showContents &&
                                                <Box className='contents-box'>
                                                    <Box className='contents'>
                                                        <Box sx={{ pl: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                            <Button size="small" startIcon={<LinkIcon />} disableRipple sx={{ padding: 0 }} onClick={handleCopyLink}>{translate('copylink')}</Button>
                                                            <IconButton size='small' onClick={() => setShowContents(false)}>
                                                                <HighlightOffIcon />
                                                            </IconButton>
                                                        </Box>
                                                        <List
                                                            component="ol"
                                                            subheader={<ListSubheader>{translate('contents')}:</ListSubheader>}
                                                            sx={{ "& > .MuiListSubheader-root": { backgroundColor: "transparent" } }}
                                                        >
                                                            <Contents />
                                                        </List>
                                                    </Box>
                                                </Box>}
                                            {!showContents &&
                                                <Box className='close-contents-box'>
                                                    <IconButton size='small' onClick={() => setShowContents(true)} sx={{ float: "right" }}>
                                                        <MenuIcon />
                                                    </IconButton>
                                                </Box>}
                                        </Box>
                                    </ReflexElement>
                                </ReflexContainer>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
}
function mapStateToProps(state) {
    return {
        BackDrop: state.BackDrop,
        SnackbarAlert: state.SnackbarAlert,
        Intl: state.Intl,
    }
}
export default connect(mapStateToProps)(withTranslate(Documentation));